import PropTypes from 'prop-types';
import {Component} from 'react';
import InputField from '../../../form/InputField';
import camelcaseToKebabcase from '../../../utils/camelcase-to-kebabcase';

class KlarnaFormFieldSet extends Component {
  legacyNames(prefix, field) {
    const kebabName = camelcaseToKebabcase(field.name);
    const nameInClass = field.nameInClass ? field.nameInClass : ` ${kebabName}-field`;
    const id = field.id ? field.id : `${kebabName}-fields`;
    
    return {
      id,
      nameInClass: ` ${nameInClass}`,
      nameOnForm: `${prefix}.${field.name}`,
      wrappedClassName: kebabName,
    };
  }

  render() {
    const {definedFields, klarnaCustomerDetails, fieldContainer} = this.props;

    const fieldNamePrefix = 'klarna';

    return definedFields.map((definedField) => {
      const key = definedField.key || `${fieldNamePrefix}--${definedField.name}`;
      const legacyNames = this.legacyNames(fieldNamePrefix, definedField);

      return (
        <InputField
          key={key}
          value={klarnaCustomerDetails[definedField.name]}
          fieldContainer={fieldContainer}
          legacyNames={legacyNames}
          fieldNamePrefix={fieldNamePrefix}
          definedField={definedField}
        />
      );
    });
  }
}

KlarnaFormFieldSet.propTypes = {
  definedFields: PropTypes.array.isRequired,
  fieldContainer: PropTypes.object.isRequired,
  klarnaCustomerDetails: PropTypes.object.isRequired,
};

export default KlarnaFormFieldSet;
